import type { Brand } from '@seek/melways-sites';

export const brandNameMapper: Record<Brand, string> = {
  seek: 'SEEK',
  jobstreet: 'Jobstreet',
  jobsdb: 'Jobsdb',
};
